import { useAuth0 } from "@auth0/auth0-react";

const LogIn = () => {
  const { loginWithRedirect, error } = useAuth0();

  return (
    <div className="flex h-screen w-full items-center justify-center bg-[#EAE8E8] p-[80px] dark:bg-[#EAE8E8]">
      <div className="flex h-[540px] w-[400px] flex-col justify-center overflow-y-auto rounded-md bg-[#FFFFFF] p-0 shadow-xl shadow-[#D9D8D8] dark:bg-[#FFFFFF]">
        <div className="flex h-[213px] w-full flex-col items-center justify-start p-[40px] pb-[24px]">
          <div className="flex w-full flex-col items-center justify-center">
            <img
              data-testid="companyLogo"
              src="/LQLogoSm1.png"
              alt="Logo"
              width={52}
              height={52}
            />
            <h1
              data-testid="welcome"
              className="mb-[16px] mt-[24px] text-[24px] text-black"
            >
              Welcome
            </h1>
            <div data-testid="logInText" className="text-black">
              Log in to Liquidity Cube
            </div>
          </div>
          <div className="pb text-lg text-black"></div>
        </div>
        <div className="flex h-[271px] w-full flex-col justify-end gap-2 p-[40px] pt-0">
          <div className="flex w-full justify-around"></div>
          <div className="flex w-full flex-col gap-2">
            {error && (
              <div
                data-testid="LogInErrorMessage"
                id="LogInErrorMessage"
                role="alert"
                className="w-full break-words text-center text-xs text-red-600"
              >
                {error.message}
              </div>
            )}
            <button
              data-testid="logInButton"
              className="mt-[4px] min-h-[52px] w-full rounded bg-[#D5570F] px-[16px] py-[4px] text-white"
              onClick={() => loginWithRedirect()}
              id="LoginButton"
            >
              Log In
            </button>
          </div>
          <div className="w-full content-center text-center text-xs text-black">
            For support, please contact:
            <a
              href="mailto:helpdesk@liquiditycube.com"
              target="_blank"
              className="text-blue-600 underline visited:text-purple-800 hover:text-blue-800 dark:text-blue-400 visited:dark:text-purple-400"
            >
              Helpdesk
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogIn;
